import React from 'react';
import { ExternalLink } from 'lucide-react';
export const LinkPreview = ({
  url
}) => {
  // Always use the ChatGPT shopping expert link
  const actualUrl = 'https://chatgpt.com/g/g-68986d8f22748191b0f4b8839c3e1cfa-shopping-expert';
  // Extract domain name for display
  const domain = 'chatgpt.com';
  // Extract product name from URL or use a generic name
  const getProductName = url => {
    // Try to extract product name from URL path
    const pathParts = url.split('/').filter(Boolean);
    const lastPart = pathParts[pathParts.length - 1];
    if (lastPart) {
      // Convert kebab-case or snake_case to Title Case
      return lastPart.replace(/[-_]/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
    }
    return 'Shopping Expert';
  };
  // Function to determine what kind of product it might be based on URL
  const getProductType = url => {
    if (url.includes('laptop')) return 'laptop';
    if (url.includes('headphone')) return 'headphones';
    if (url.includes('camera')) return 'camera';
    if (url.includes('phone')) return 'smartphone';
    return 'product';
  };
  // Get placeholder image based on product type
  const getPlaceholderImage = type => {
    switch (type) {
      case 'laptop':
        return 'https://images.unsplash.com/photo-1496181133206-80ce9b88a853?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80';
      case 'headphones':
        return 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80';
      case 'camera':
        return 'https://images.unsplash.com/photo-1516035069371-29a1b244cc32?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80';
      case 'smartphone':
        return 'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80';
      default:
        return 'https://images.unsplash.com/photo-1523275335684-37898b6baf30?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80';
    }
  };
  const productType = getProductType(url);
  const imageUrl = getPlaceholderImage(productType);
  const productName = getProductName(url);
  return <a href={actualUrl} target="_blank" rel="noopener noreferrer" className="block mt-2 mb-2 border border-gray-200 rounded-lg overflow-hidden hover:shadow-md transition-shadow" data-id="element-159">
      <div className="flex" data-id="element-160">
        <div className="w-16 h-16 sm:w-24 sm:h-24 bg-gray-100 flex-shrink-0" data-id="element-161">
          <img src={imageUrl} alt={`${productType} preview`} className="w-full h-full object-cover" data-id="element-162" />
        </div>
        <div className="p-2 sm:p-3 flex-1" data-id="element-163">
          <div className="flex items-center text-xs text-gray-500 mb-1" data-id="element-164">
            <ExternalLink size={12} className="mr-1" data-id="element-165" />
            {domain}
          </div>
          <h3 className="font-medium text-xs sm:text-sm" data-id="element-166">{productName}</h3>
          <p className="text-xs text-gray-500 mt-1 hidden sm:block" data-id="element-167">
            Click to view product details
          </p>
        </div>
      </div>
    </a>;
};